var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRadioCheckedBlue4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 -0.000976562C15.5233 -0.000976562 20.0011 4.47687 20.0011 10.0006C20.0011 15.5243 15.5233 20.0021 9.9996 20.0021C4.47589 20.0021 -0.00195312 15.5243 -0.00195312 10.0006C-0.00195312 4.47687 4.47589 -0.000976562 9.9996 -0.000976562ZM9.9996 1.49902C5.30432 1.49902 1.49805 5.3053 1.49805 10.0006C1.49805 14.6959 5.30432 18.5021 9.9996 18.5021C14.6949 18.5021 18.5011 14.6959 18.5011 10.0006C18.5011 5.3053 14.6949 1.49902 9.9996 1.49902ZM9.99616 3.99902C13.3088 3.99902 15.9943 6.68447 15.9943 9.99714C15.9943 13.3098 13.3088 15.9953 9.99616 15.9953C6.68349 15.9953 3.99805 13.3098 3.99805 9.99714C3.99805 6.68447 6.68349 3.99902 9.99616 3.99902Z",
    fill: "#166DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRadioCheckedBlue4);
export default __webpack_public_path__ + "static/media/icon-radio-checked-blue4.d39e0c9041aa5a502d0ff6dabda83fb4.svg";
export { ForwardRef as ReactComponent };